module.exports = __webpack_public_path__ + "img/splash.da24222e.jpg";